
import { Component, Input } from '@angular/core';
import { NgbProgressbar } from '@ng-bootstrap/ng-bootstrap';
@Component({
    selector: 'app-loading-dialog',
    templateUrl: './loading-dialog.component.html',
    styleUrls: ['./loading-dialog.component.scss'],
    imports: [NgbProgressbar]
})
export class LoadingDialogComponent {
  timer = 0;
  intervalInstance: any;
  @Input('title') public title: string | undefined;
  @Input('subtitle') public subtitle: string | undefined;
  constructor() {}

  ngOnInit(): void {
    this.intervalInstance = setInterval(() => {
      this.timer = this.timer > 10000 ? -5 : (this.timer += 1);
    }, 100);
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalInstance);
  }
}
